import { AppProvider, Frame } from '@shopify/polaris'
import enTranslations from '@shopify/polaris/locales/en.json'
import '@shopify/polaris/build/esm/styles.css'
import { Link } from 'react-router-dom'

// Bridge Polaris's internal anchor component to React Router so all
// Navigation items and Polaris links use client-side routing.
function RouterLink({
  url,
  children,
  ...rest
}: React.AnchorHTMLAttributes<HTMLAnchorElement> & { url: string }) {
  if (url.startsWith('http') || url.startsWith('mailto:')) {
    return (
      <a href={url} {...rest}>
        {children}
      </a>
    )
  }
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <Link to={url} {...(rest as any)}>
      {children}
    </Link>
  )
}

type Props = { children: React.ReactNode }

export function PolarisProvider({ children }: Props) {
  return (
    <AppProvider i18n={enTranslations} linkComponent={RouterLink}>
      <Frame>{children}</Frame>
    </AppProvider>
  )
}
